import React, { useState, useEffect } from "react";
import styles from "./galeria_wedson_rodrigues_.module.scss";
import InstagramIcon from '../../icons/instagramIcon.tsx';
import MapsIcon from '../../icons/mapsIcon.tsx';
import WhatsappIcon from '../../icons/whatsappIcon.tsx';
import { Link } from "react-router-dom";
import { FaArrowLeft, FaChevronLeft, FaChevronRight, FaTimes, FaArrowUp } from "react-icons/fa";

// Imagens de exemplo por categoria
import galNeoTradicional1 from './src/galeria/galNeoTradicional1.jpeg';
import galNeoTradicional2 from './src/galeria/galNeoTradicional2.jpeg';
import galNeoTradicional3 from './src/galeria/galNeoTradicional3.jpeg';
import galNeoTradicional4 from './src/galeria/galNeoTradicional4.jpeg';
import galNeoTradicional5 from './src/galeria/galNeoTradicional5.jpeg';
import galNeoTradicional6 from './src/galeria/galNeoTradicional6.jpeg';
import galNeoTradicional7 from './src/galeria/galNeoTradicional7.jpeg';
import galNeoTradicional8 from './src/galeria/galNeoTradicional8.jpeg';
import galNeoTradicional9 from './src/galeria/galNeoTradicional9.jpeg';
import galNeoTradicional10 from './src/galeria/galNeoTradicional10.jpeg';
import galNeoTradicional11 from './src/galeria/galNeoTradicional11.jpeg';
import galNeoTradicional12 from './src/galeria/galNeoTradicional12.jpeg';
import galNeoTradicional13 from './src/galeria/galNeoTradicional13.jpeg';
import galNeoTradicional14 from './src/galeria/galNeoTradicional14.jpeg';
import galNeoTradicional15 from './src/galeria/galNeoTradicional15.jpeg';
import galNeoTradicional16 from './src/galeria/galNeoTradicional16.jpeg';
import galPretaCinza1 from './src/galeria/galPretaCinza1.jpeg';
import galPretaCinza2 from './src/galeria/galPretaCinza2.jpeg';
import galPretaCinza3 from './src/galeria/galPretaCinza3.jpeg';
import galPretaCinza4 from './src/galeria/galPretaCinza4.jpeg';
import galPretaCinza5 from './src/galeria/galPretaCinza5.jpeg';
import galPretaCinza6 from './src/galeria/galPretaCinza6.jpeg';
import galPretaCinza7 from './src/galeria/galPretaCinza7.jpeg';
import galPretaCinza8 from './src/galeria/galPretaCinza8.jpeg';
import galPretaCinza9 from './src/galeria/galPretaCinza9.jpeg';
import galPretaCinza10 from './src/galeria/galPretaCinza10.jpeg';
import galColorida1 from './src/galeria/galColorida1.jpeg';
import galColorida2 from './src/galeria/galColorida2.jpeg';
import galColorida3 from './src/galeria/galColorida3.jpeg';
import galColorida4 from './src/galeria/galColorida4.jpeg';
import galColorida5 from './src/galeria/galColorida5.jpeg';
import galColorida6 from './src/galeria/galColorida6.jpeg';
import galFineLine1 from './src/galeria/galFineLine1.jpeg';
import galFineLine2 from './src/galeria/galFineLine2.jpeg';
import galFineLine3 from './src/galeria/galFineLine3.jpeg';
import galFineLine4 from './src/galeria/galFineLine4.jpeg';

const Galeria_wedson_rodrigues_: React.FC = () => {
    const [selectedCategory, setSelectedCategory] = useState<string | null>(null);
    const [lightboxOpen, setLightboxOpen] = useState(false);
    const [currentIndex, setCurrentIndex] = useState(0);
    const [showScrollTop, setShowScrollTop] = useState(false);

    // Mapeamento das imagens por categoria
    const categories: { [key: string]: { label: string; images: string[] } } = {
        neoTradicional: {
            label: "Neo Tradicional", images: [galNeoTradicional1, galNeoTradicional2, galNeoTradicional3, galNeoTradicional4, galNeoTradicional5, galNeoTradicional6, galNeoTradicional7, galNeoTradicional8, galNeoTradicional9, galNeoTradicional10, galNeoTradicional11, galNeoTradicional12, galNeoTradicional13, galNeoTradicional14, galNeoTradicional15, galNeoTradicional16]
        },
        pretaCinza: { label: "Preta e Cinza", images: [galPretaCinza1, galPretaCinza2, galPretaCinza3, galPretaCinza4, galPretaCinza5, galPretaCinza6, galPretaCinza7, galPretaCinza8, galPretaCinza9, galPretaCinza10] },
        colorida: { label: "Colorida", images: [galColorida1, galColorida2, galColorida3, galColorida4, galColorida5, galColorida6] },
        fineLine: { label: "Fine Line", images: [galFineLine1, galFineLine2, galFineLine3, galFineLine4] },
    };

    const imagens = selectedCategory ? categories[selectedCategory].images : [];

    const openLightbox = (index: number) => {
        setCurrentIndex(index);
        setLightboxOpen(true);
    };

    const closeLightbox = () => setLightboxOpen(false);
    const prevImage = () =>
        setCurrentIndex((prev) => (prev === 0 ? imagens.length - 1 : prev - 1));
    const nextImage = () =>
        setCurrentIndex((prev) => (prev === imagens.length - 1 ? 0 : prev + 1));

    useEffect(() => {
        const handleScroll = () => {
            setShowScrollTop(window.scrollY > 300);
        };
        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    const scrollToTop = () => {
        window.scrollTo({ top: 0, behavior: "smooth" });
    };

    return (
        <div className={styles.galeria_wedson_rodrigues_}>
            {/* HEADER */}
            <div className={styles.header}>
                <Link to="/wedson_rodrigues_" className={styles.backButton}>
                    <FaArrowLeft />
                </Link>
                <h1 className="mb-0">{selectedCategory ? categories[selectedCategory].label : "Tattoo's"}</h1>
            </div>

            {/* CONTEÚDO */}
            <div className={styles.content}>
                {!selectedCategory ? (
                    <div className={styles.categoryGrid}>
                        {Object.entries(categories).map(([key, cat]) => (
                            <div
                                key={key}
                                className={styles.categoryCard}
                                onClick={() => setSelectedCategory(key)}
                            >
                                <img src={cat.images[0]} alt={cat.label} />
                                <span>{cat.label}</span>
                            </div>
                        ))}
                    </div>
                ) : (
                    <div className={styles.galleryGrid}>
                        <button className={styles.backToCategories} onClick={() => setSelectedCategory(null)}>
                            Voltar às Categorias
                        </button>
                        {imagens.map((img, index) => (
                            <div
                                key={index}
                                className={styles.imageContainer}
                                onClick={() => openLightbox(index)}
                            >
                                <img src={img} alt={`Galeria ${index + 1}`} />
                            </div>
                        ))}
                    </div>
                )}
            </div>

            {/* Lightbox */}
            {lightboxOpen && (
                <div className={styles.lightbox}>
                    <button className={styles.closeBtn} onClick={closeLightbox}>
                        <FaTimes />
                    </button>
                    <button className={styles.prevBtn} onClick={prevImage}>
                        <FaChevronLeft />
                    </button>
                    <img
                        src={imagens[currentIndex]}
                        alt={`Galeria ${currentIndex + 1}`}
                        className={styles.lightboxImage}
                    />
                    <button className={styles.nextBtn} onClick={nextImage}>
                        <FaChevronRight />
                    </button>
                </div>
            )}

            {/* BOTÃO FLUTUANTE */}
            {showScrollTop && (
                <button className={styles.scrollTopButton} onClick={scrollToTop}>
                    <FaArrowUp />
                </button>
            )}

            {/* FOOTER */}
            <div className={styles.footer}>
                <div className={styles.divSocials}>
                    <a
                        href="https://wa.me/5517992176906?text=Olá, vim pelo link na bio e gostaria de mais informações..."
                        target="_blank"
                    >
                        <div className={styles.socials}>
                            <div className={styles.iconPlaceholder}>
                                <WhatsappIcon height="30" color="#ffffff" />
                            </div>
                            <span>WhatsApp</span>
                        </div>
                    </a>
                    <a href="https://maps.app.goo.gl/Q7x2Qq3FkowMMJzd7" target="_blank">
                        <div className={styles.socials}>
                            <div className={styles.iconPlaceholder}>
                                <MapsIcon height="30" color="#ffffff" />
                            </div>
                            <span>Localização</span>
                        </div>
                    </a>
                    <a
                        href="https://www.instagram.com/wedson.rodrigues_?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw=="
                        target="_blank"
                    >
                        <div className={styles.socials}>
                            <div className={styles.iconPlaceholder}>
                                <InstagramIcon height="26" color="#ffffff" />
                            </div>
                            <span>Instagram</span>
                        </div>
                    </a>
                </div>
                <div className={styles.signature}>
                    Desenvolvido por{" "}
                    <a href="https://www.linksvibe.com.br" target="_blank" rel="noreferrer">
                        Links Vibe
                    </a>
                </div>
            </div>
        </div>
    );
};

export default Galeria_wedson_rodrigues_;
